var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParasites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000029012725306650259740000014092553615413890729_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.9,35.9V15.2c0-2.8-2.4-5.2-5.2-5.2s-5.2,2.4-5.2,5.2v17.5L68.6,37c-1.2-1.1-2.7-2.1-4.2-2.9 c1.7-2.5,2.6-5.4,2.6-8.7c0-8.6-7-15.5-15.5-15.5S36,16.9,36,25.4c0,3.2,1,6.2,2.6,8.7c-1.5,0.9-2.8,1.8-4.2,2.9l-8.9-4.4V15.2 c0-2.8-2.4-5.2-5.2-5.2s-5.2,2.4-5.2,5.2v20.7c0,1.9,1.1,3.7,2.8,4.6l10,5c-1.6,3.4-2.5,7.1-2.5,11c0,0.7,0,1.2,0.1,1.9L18,62.2 c-1.8,0.9-2.8,2.7-2.8,4.6v21.1c0,2.8,2.4,5.2,5.2,5.2s5.2-2.4,5.2-5.2V70l3-1.5c4.4,8.2,12.9,13.9,22.9,13.9S70,76.8,74.4,68.6 l3,1.5v17.8c0,2.8,2.4,5.2,5.2,5.2c2.8,0,5.2-2.4,5.2-5.2v-21c0-1.9-1.1-3.7-2.8-4.6l-7.5-3.8c0-0.7,0.1-1.2,0.1-1.9 c0-3.9-0.9-7.7-2.5-11l10-5C86.9,39.6,87.9,37.8,87.9,35.9z M51.7,20.4c2.8,0,5.2,2.4,5.2,5.2s-2.4,5.2-5.2,5.2s-5.2-2.4-5.2-5.2 S48.9,20.4,51.7,20.4z M51.7,72.1c-8.6,0-15.5-7-15.5-15.5S43.2,41,51.7,41s15.5,7,15.5,15.5S60.3,72.1,51.7,72.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000049944316207877305150000007534412799072284857_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 51.7,
    cy: 25.6,
    r: 10.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 51.7,
    cy: 59,
    r: 21.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.8,45.3l11.9-8.5c1.5-1,2.2-2.8,2-4.6L81.1,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.5,45.3l-11.9-8.5c-1.5-1-2.2-2.8-2-4.6L22.2,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.5,62.7l6.5,3.4c1.3,0.7,2.1,2,2.1,3.4v21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.9,62.7l-6.5,3.4c-1.3,0.7-2.1,2-2.1,3.4v21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParasites);
export default __webpack_public_path__ + "static/media/parasites.dc79e2a74edc64c774b51ffd24a1311b.svg";
export { ForwardRef as ReactComponent };